import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbDropdownModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { IconThemeReverseModule, RadioModule } from '../../../../shared';
import { HeaderNavigationItemModule } from '../../components/header-navigation-item';
import { MenuSiteContextComponent } from './menu-site-context.component';

@NgModule({
  declarations: [MenuSiteContextComponent],
  imports: [
    NzIconModule,
    CommonModule,
    HeaderNavigationItemModule,
    NgbPopoverModule,
    NgbDropdownModule,
    I18nModule,
    RadioModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MenuSiteContextComponent: {
          component: MenuSiteContextComponent,
        },
      },
    }),
    IconThemeReverseModule,
  ],
  providers: [],
  exports: [MenuSiteContextComponent],
})
export class MenuSiteContextModule {}
